import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-941bdd0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "centre-text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TickCrossBooleanDisplay',
  props: {
    value: { type: Boolean }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.value)
      ? _renderSlot(_ctx.$slots, "true", { key: 0 }, () => [
          _createTextVNode(" ✅ ")
        ])
      : ((_ctx.value === undefined || _ctx.value === null))
        ? _renderSlot(_ctx.$slots, "null", { key: 1 }, () => [
            _createTextVNode(_toDisplayString(_ctx.value), 1)
          ])
        : _renderSlot(_ctx.$slots, "false", { key: 2 }, () => [
            _createTextVNode(" ❌ ")
          ])
  ]))
}
}

})